import { CurrencyPipe, DatePipe } from '@angular/common';
import { Provider } from '@angular/core';

import { STORE_PREFIX, runOnAppInit } from '@frontend/vanilla/core';

import { ValidatorsExtended } from './forms/validators-extended';
import { PortalProductBootstrapper } from './portal-unicode-bootstrapper';
import { TimeoutResolve } from './timeout-resolve';

export function portalProviders(): Provider[] {
    return [
        { provide: STORE_PREFIX, useValue: 'portal.' },
        runOnAppInit(PortalProductBootstrapper),
        TimeoutResolve,
        CurrencyPipe,
        DatePipe,
        {
            provide: 'popperDefaults',
            useValue: { placement: 'bottom', trigger: 'click' },
        },
        ValidatorsExtended,
    ];
}

/* Create Global singleton instance used across app
 - Must have above pipe's based on usage as part of standalone component level providers
   if 'pipe.transform' is used in .ts 
 Note: After standalone migration remove pipes from above as components works independently */
